import { render, staticRenderFns } from "./authentication-callback.vue?vue&type=template&id=6d7c940a&"
import script from "./authentication-callback.vue?vue&type=script&lang=ts&"
export * from "./authentication-callback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports